export const pallet = {
  skyblue: ['#BDE0FE', '#78BEFF', '#46A6FF'],
  gray: ['#EBEFF2', '#A6B0BA', '#222222'],
};
